import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { LogoUrl } from 'src/app/core/constants/constants';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';
import { RegData } from 'src/app/core/dtos/reg-data';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectRegData } from 'src/app/state/reg-data.selectors';
import { TestPurposeEnum, TestTypeEnum } from 'src/app/core/dtos/enum';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-selected-test-info',
  templateUrl: './selected-test-info.component.html',
  styleUrls: ['./selected-test-info.component.scss']
})

export class SelectedTestInfoComponent implements OnInit, OnDestroy {
  @Input() isCelpipOnline: boolean;
  @Input() isCELPIPTestSelection: boolean;
  regData: RegData;
  testLogo: string;
  testDescription: string[];
  localTimeZone: string;
  formatTestDateTime: string;
  regDataSubscription: Subscription;
  testTypeDisplayName: string;
  hidePR: boolean;
  testDate: Date;

  constructor(
    private configHelper: ConfigHelper,
    private dateTimeHelper: DateTimeHelper,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.regDataSubscription = this.store.select(selectRegData).pipe(take(1))
      .subscribe(
        result => {
          this.regData = result;
          this.hidePR = this.isCelpipOnline || this.regData?.selectedTestPurposeOption?.parentId === 'null_2'
            || this.regData?.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.CICC
            || this.regData?.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.RealEstateCouncilofBC
            || this.regData?.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.RECA
            || this.regData?.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.SaskatchewanRealtors
            || this.regData?.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.AdmissionToInstitution
            || this.regData?.testSession?.testTypeId === TestTypeEnum.CELPIP_LS
            || this.regData?.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.CollegeOfPhysiciansAndSurgeons
            || this.regData?.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.CollegeOfDenturists;
          //condition is met only for cael online (upload photo and ID)
          if (this.regData?.testSession?.testDateTimeUtc) {
            this.testDate = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(this.regData.testSession.testDateTimeUtc));
            this.localTimeZone = this.dateTimeHelper.getLocalTimeZone();
          }
          this.getTestInfo();
        }
      );
  }

  public get TestTypeEnum() {
    return TestTypeEnum;
  }

  public get TestPurposeEnum() {
    return TestPurposeEnum;
  }

  getTestInfo() {
    //this component is only used for celpip, celpip ls and cael online
    const celpipGInfo = 'A four-skills (listening, reading, writing, and speaking) English language proficiency test used to assess functional language proficiency.';
    const celpipLSInfo = 'This is a two-skills (listening and speaking) English language proficiency test used to assess functional language proficiency.';
    switch (this.regData?.testSession?.testTypeId) {
      case TestTypeEnum.CELPIP_G:
        this.testLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CELPIP_GENERAL_LOGO"));
        this.testTypeDisplayName = this.isCelpipOnline ? `<strong>CELPIP-General Online - </strong> ${celpipGInfo}` : `<strong>CELPIP-General - </strong>${celpipGInfo}`;
        break;

      case TestTypeEnum.CELPIP_LS:
        this.testLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CELPIP_LS_LOGO"));
        this.testTypeDisplayName = this.isCelpipOnline ? `<strong>CELPIP-General LS Online - </strong> ${celpipLSInfo}` : `<strong>CELPIP-General LS - </strong>${celpipLSInfo}`;
        break;

      case TestTypeEnum.PRETEST_G:
        this.testLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CELPIP_GENERAL_LOGO"));
        this.testTypeDisplayName = `<strong>Pretest CELPIP-General - </strong> ${celpipGInfo}`;
        break;

      case TestTypeEnum.PRETEST_LS:
        this.testLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CELPIP_LS_LOGO"));
        this.testTypeDisplayName = `<strong>Pretest CELPIP-General LS -</strong> ${celpipLSInfo}`;
        break;

      case TestTypeEnum.CELPIP_SAFT:
        this.testLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CELPIP_PRETEST_LOGO"));
        this.testTypeDisplayName = `<strong>CELPIP Pretest - </strong>Practice questions for the Listening and Reading components of the CELPIP Test.`;
        break;

      case TestTypeEnum.CAEL2:
        this.testLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CAEL_CE_LOGO"));
        this.testTypeDisplayName = "CAEL ONLINE";
        break;

      default:
        break;
    }
  }

  ngOnDestroy() {
    this.regDataSubscription?.unsubscribe();
  }

}
